import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import MonthPickerInput from 'react-month-picker-calendar';
import StatefulMultiSelect from "@khanacademy/react-multi-select";
import CustomersPowerSelect from '../customers/customers-power-select.jsx';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class MonthlyConfirmedJobsAbortedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            selectedCustomerId: null,
            selectedCustomer: null,
            confirmedJobs:[],
            totalJobs:null,
            totalAbortedJobs:null,
            url:'/api/v1/portal/portal-admin/monthly-confirmed-jobs-aborted-jobs-report/',
            downloadReportName: 'Total & Aborted job '+moment().format("MMMM")+ ' Report.xlsx',
            yearSelection:moment().year(),
            monthSelection:moment().month()+1,
            displayMonthSelection:"",
        };
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    buildMonthOptions() {
        var arr = [];
        for (let i = 1; i <= 12; i++) {
        arr.push(<option key={i} value={i}>{moment(i, 'MM').format('MMM')}</option>)
        }
        return arr; 
    }
    buildYearOptions() {
        var arr = [];
        for (let i = 1; i <= 5; i++) {
            let nyear = moment().add(i, 'years').format('YYYY');
            arr.push(<option key={i+nyear} value={nyear}>{nyear}</option>)
        }
        return arr; 
    }
    buildPrevYearOptions() {
        var arr = [];
        for (let i = 5; i >= 1; i--) {
            let pyear = moment().subtract(i, 'years').format('YYYY');
            arr.push(<option key={i+pyear} value={pyear}>{pyear}</option>)
        }
        return arr; 
    }
    handleMonthChange(e){
        this.setState({monthSelection:e.target.value});
    }
    handleYearChange(e){
        this.setState({yearSelection:e.target.value});
    }
    handleMonthlyTotalJobsAbortedJobsReportGeneration(e) {
        let url = this.state.url+this.state.monthSelection+'-'+this.state.yearSelection+'/'+this.state.selectedCustomerId;
        this.setState({isLoading: true});
        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((res) => {
            this.setState({confirmedJobs:res.jobs});
            this.setState({totalJobs:res.totalJobs});
            this.setState({totalAbortedJobs:res.totalAbortedJobs});
            this.setState({isLoading: false});
          });
        });
    }
    handleCustomerSelection(option) {
        if (option) {
          this.setState({
            selectedCustomer: option,
            selectedCustomerId: option.id,
            downloadReportName: 'Total & Aborted job - '+option.name+" "+moment(this.state.monthSelection, 'MM').format('MMM')+' '+this.state.yearSelection+ ' Report.xlsx'
          });
        }
      }
      handleJobReportGeneration(filename) {
        filename = 'Total & Aborted job - '+this.state.selectedCustomer.name+" "+moment(this.state.monthSelection, 'MM').format('MMM')+' '+this.state.yearSelection+ ' Report.xlsx';
        if(this.state.selectedCustomerId && this.state.monthSelection){
            let url = "/api/v1/portal/finance/monthly-total-aborted-job-report/"+this.state.monthSelection+'-'+this.state.yearSelection+'/'+this.state.selectedCustomerId;
            return fetch(url,{
                method: "GET",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                "Authorization": 'Bearer ' + window.api_token
                , "Accept": 'application/json',
                'Content-Type': 'multipart/form-data'
                }
            }
            ).then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a); 
                a.click();    
                a.remove(); 
            }).catch(err=>{
            alert('sorry something went wrong.') ;
            });
        }
      }
    
    render() {
        let jobsData = [];
        let totalJobs = this.state.totalJobs;
        let totalAbortedJobs = this.state.totalAbortedJobs;
        let downloadableCsvDataAborted = "Job Ref,Person Name,Confirmed On,Status,Reason\n";
        if(this.state.confirmedJobs && this.state.confirmedJobs.length > 0){
            this.state.confirmedJobs.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                let personName = JSON.parse(currentJob.call_details);
                let confirmedOn = (currentJob.confirmed_on_site_date_time) ? moment(currentJob.confirmed_on_site_date_time).format('ddd Do MMM YYYY - HH:mm:ss').toString() : "";
                let abortReason = (currentJob.abortion_reason) ? currentJob.abortion_reason : "";
                
                jobsData.push(
                    <tr key={index} className="job-ref-font16">
                        <td><a href={joburl}>{currentJob.id}</a></td>
                        <td>{personName.customer_name}</td>
                        <td>{confirmedOn}</td>
                        <td>{currentJob.status}</td>
                        <td>{abortReason}</td>
                    </tr>
                );
                downloadableCsvDataAborted = downloadableCsvDataAborted +
                                        currentJob.id+','+
                                        personName.customer_name+','+
                                        confirmedOn+','+
                                        currentJob.status+','+
                                        abortReason+"\n";
            });
            
        }else{
            jobsData.push(
                <tr key='no-records'>
                    <td colSpan="6" className='text-center'>No records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Monthly Cofirmed + Aborted Jobs Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-3 col-sm-12">
                        <label><h3>Select Customer</h3></label><br/>
                            <div>
                            <CustomersPowerSelect handleCustomerSelection={this.handleCustomerSelection} />
                            </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group month_picker">
                            <label><h3>Select Month:</h3></label>
                            <select className="form-control" id="months" defaultValue={this.state.monthSelection} onChange={(e)=>this.handleMonthChange(e)}>
                                {this.buildMonthOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label><h3>Select Year:</h3></label>
                            <select className="form-control" id="years" defaultValue={this.state.yearSelection} onChange={(e)=>this.handleYearChange(e)}>
                                {this.buildPrevYearOptions()}
                                <option key={moment().year()} value={moment().year()}>{moment().year()}</option>
                                {this.buildYearOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success daily-delivered-btn-margin" onClick={(e) => this.handleMonthlyTotalJobsAbortedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate {moment(this.state.monthSelection, 'MM').format('MMM')} {this.state.yearSelection} Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg daily-delivered-btn-margin"
                                    onClick={(e) => {
                                    this.handleJobReportGeneration(this.state.downloadReportName);
                                  }}>
                                <i className="fa fa-download"></i> Download {moment(this.state.monthSelection, 'MM').format('MMM')} {this.state.yearSelection}  Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-11 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <div className="job-ref-font16">
                                <h4>Total Jobs: {(totalJobs) ? totalJobs : 0}</h4>
                                <h4>Total Aborted Jobs: {(totalAbortedJobs) ? totalAbortedJobs : 0}</h4><br/>
                            </div>
                            <table className="daily-delivered-report-tbl">
                                <thead>
                                    <tr>
                                        <th className="text-center">Job</th>
                                        <th className="text-center">person name</th>
                                        <th className="text-center">Confirmed On</th>
                                        <th className="text-center">status</th>
                                        <th className="text-center">reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="6"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    jobsData
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-monthly_confirmed_jobs_aborted_jobs_report')) {
    ReactDOM.render(
        <MonthlyConfirmedJobsAbortedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-monthly_confirmed_jobs_aborted_jobs_report')
    );
}
